import { useRoutes } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
//import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import ProductDetailsPageTwo from "./pages/ProductDetailsPageTwo";
import CartPage from "./pages/CartPage";
// import AccountPage from "./pages/AccountPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import ContactPage from "./pages/ContactPage";
import VendorPage from "./pages/VendorPage";
import VendorDetailsPage from "./pages/VendorDetailsPage";
import VendorTwoPage from "./pages/VendorTwoPage";
import VendorTwoDetailsPage from "./pages/VendorTwoDetailsPage";
// import BecomeSellerPage from "./pages/BecomeSellerPage";
import WishlistPage from "./pages/WishlistPage";
import OurStory from "./pages/company_info/OurStory";
import SignUp from "./pages/my_account/SignUp";
import ConfirmInvitation from "./pages/my_account/ConfirmInvitation";
import Login from "./pages/my_account/Login";
import Logout from "../src/components/my_account/LogoutPage";
import ForgotPassword from "./pages/my_account/ForgotPassword";
import ForgotPasswordMail from "./pages/my_account/ForgotPasswordMail";
import AccountCreated from "./pages/my_account/AccountCreated";
import AccountConfirmation from "./pages/my_account/AccountConfirmation";
import ConfirmationExpired from "./pages/my_account/ConfirmationExpired";
// Company info
import AboutUs from "./pages/company_info/AboutUs";
import OurBrands from "./pages/company_info/OurBrands";
//Self Service
import DashBoard from "./pages/self_service/DashBoard";
import Credit from "./pages/self_service/Credit";
import ActiveOrders from "./pages/self_service/ActiveOrders";
import OrdersTracking from "./pages/self_service/OrdersTracking";
import AgreedProducts from "./pages/self_service/AgreedProducts";
import MyCompany from "./pages/self_service/MyCompany";
import CompanyAddressActions from "./pages/self_service/CompanyAddressActions";
import SelfServiceMe from "./pages/self_service/SelfServiceMe";
import Users from "./pages/self_service/Users";
import UsersActions from "./pages/self_service/UsersActions";
//product
import ProductList from "./pages/product_list/ProductList";
import ProductDetail from "./pages/product_list/ProductDetail";
import SearchProductList from "./pages/product_list/SearchProductList";
//cart
import OneTimeCart from "./pages/cart/OneTimeCart";
import CheckOut from "./pages/checkout/CheckOut";
import ThankYou from "./pages/thankyou/ThankYou";
// RFQ
import Rfq from "./pages/rfq/Rfq";
//Comparison
import CompareProducts from "./pages/comparison/CompareProducts";
//become a seller
import BecomeASellerPage from "./pages/company_info/BecomeASellerPage";
import SelfServiceMeUserNotification from "./pages/self_service/SelfServiceMeUserNotification";
import ContactUs from "./pages/company_info/ContactUs";
// Tips & Tricks
import TipsAndTicks from "./pages/tips_and_tricks/TipsAndTicks";

const AppRoutes = () => {
  const routes = useRoutes([
    { path: "/", element: <HomePageOne /> },
    { path: "/index-two", element: <HomePageTwo /> },
    { path: "/index-three", element: <HomePageThree /> },
    { path: "/shop", element: <HomePageOne /> },
    { path: "/product-details", element: <ProductDetailsPageOne /> },
    { path: "/product-details-two", element: <ProductDetailsPageTwo /> },
    { path: "/cart", element: <CartPage /> },
    //{ path: "/checkout", element: <CheckoutPage /> },
    //{ path: "/become-seller", element: <BecomeSellerPage /> },
    { path: "/wishlist", element: <WishlistPage /> },
    // { path: '/account', element: <AccountPage /> },
    { path: "/blog", element: <BlogPage /> },
    { path: "/blog-details", element: <BlogDetailsPage /> },
    { path: "/contact", element: <ContactPage /> },
    { path: "/vendor", element: <VendorPage /> },
    { path: "/vendor-details", element: <VendorDetailsPage /> },
    { path: "/vendor-two", element: <VendorTwoPage /> },
    { path: "/vendor-two-details", element: <VendorTwoDetailsPage /> },
    { path: "/account", element: <SignUp /> },
    { path: "/account-created", element: <AccountCreated /> },
    { path: "/auth/confirm-invitation", element: <ConfirmInvitation /> },
    { path: "/login", element: <Login /> },
    { path: "/logout", element: <Logout /> },
    { path: "/forgot-password", element: <ForgotPassword /> },
    { path: "/forgot-password-mail", element: <ForgotPasswordMail /> },
    { path: "/auth/account-confirmation", element: <AccountConfirmation /> },
    { path: "/auth/confirmation-expired", element: <ConfirmationExpired /> },
    // Company info
    { path: "/company-info/our-story", element: <OurStory /> },
    { path: "/company-info/about-us", element: <AboutUs /> },
    { path: "/company-info/our-brands", element: <OurBrands /> },
    //Self Service
    { path: "/self-service/dashboard", element: <DashBoard /> },
    { path: "/self-service/apply-for-credit", element: <Credit /> },
    { path: "/self-service/orders", element: <ActiveOrders /> },
    { path: "/self-service/track-orders", element: <OrdersTracking /> },
    { path: "/self-service/agreedproducts", element: <AgreedProducts /> },
    { path: "/self-service/mycompany", element: <MyCompany /> },
    {
      path: "/self-service/mycompany/actions/:id?",
      element: <CompanyAddressActions />,
    },
    { path: "/self-service/profile", element: <SelfServiceMe /> },
    { path: "/self-service/users", element: <Users /> },
    { path: "/self-service/users/action/edit/:id?", element: <UsersActions /> },
    //product
    { path: "/products/:product_category", element: <ProductList /> },
    { path: "/product-details/:product_url", element: <ProductDetail /> },
    { path: "/search", element: <SearchProductList /> },
    //cart
    { path: "/cart/one-time", element: <OneTimeCart /> },
    { path: "/checkout", element: <CheckOut /> },
    { path: "/thank-you", element: <ThankYou /> },
    //{ path: "/cart/shopping-basket", element: <ShoppingBasket /> },
    // RFQ
    { path: "/rfq", element: <Rfq /> },
    //Comparison
    { path: "/comparison", element: <CompareProducts /> },
    { path: "/become-a-customer", element: <BecomeASellerPage /> },
    {
      path: "/self-service/user-notification",
      element: <SelfServiceMeUserNotification />,
    },
    { path: "/company-info/contact-us", element: <ContactUs /> },
    // Tips & Tricks
    { path: "/tips-and-tricks", element: <TipsAndTicks /> },
  ]);

  return routes;
};

export default AppRoutes;
